'use client';

import React, { useEffect } from 'react';
import styles from './helpCenterContainer.module.scss';
import HelpCenterFullView from './helpCenterFullView';
import HelpCenterMiniView from './helpCenterMiniView';
import { useSearchParams } from 'next/navigation';
import OHCContext from '@/providers/OHCContext';

interface HelpCenterContainerProps {
  id?: string;
}

const HelpCenterContainer: React.FC<HelpCenterContainerProps> = ({ id }) => {

  const searchParams = useSearchParams();
  const searchQueryValue = searchParams.get('searchQuery') || '';
  const { setSearchQuery, isDesktopMode } = React.useContext(OHCContext);

  useEffect(() => {
    // Update search query state when the searchParams change
    if (searchQueryValue) {
      setSearchQuery(searchQueryValue);
    } else {
      setSearchQuery('');
    }
  }, [searchQueryValue, setSearchQuery]);

  return (
    <main id="page-content" className={styles.container} aria-label="Help Center" tabIndex={-1}>
      {isDesktopMode ? <HelpCenterFullView id={id} /> : <HelpCenterMiniView id={id} />}
    </main>
  );
};

export default HelpCenterContainer;
